<template>
  <div class="section-wrap">
    <div class="multi-item-title mt-40">
      <h3 class="section-title ">자기소개서</h3>
      <div class="check-util">
        <div class="check-wrap"><input type="checkbox" id="after" v-model="selfIntroUseYn" true-value="N" false-value="Y" title="나중에 작성할게요. 선택"><label for="after"><span>나중에 작성할게요.</span></label></div>
        <button type="button" class="btn btn-line-box btn-sm" @click="reset">
          <i class="ico ico-refresh"></i>
          입력항목 초기화
        </button>
      </div>
    </div>
    <div class="table-wrap mt-16">
      <table class="table-body-only">
        <caption>자기소개서 표</caption>
        <colgroup>
          <col />
        </colgroup>
        <tbody>
          <tr>
            <td>
              <div class="text-box-section resume-area">
                <textarea
                  class="text-area-wrap"
                  v-model="introduction.selfintro"
                  :disabled="isDisabled"
                  title="자기소개서 내용"
                  @input="handleSelfIntroInput"
                ></textarea>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="border-line-box self-introduction-notice mt-16">
      <div class="tit">자기소개서 작성</div>
      <ul class="list-type-dot mt-16">
        <li>
          자기소개서의 정답은 없지만 보편적으로 자기소개서에는 다음과 같은 내용을 서술하여 작성합니다.
          <div class="description">
            - 성장과정, 성격의 장단점, 지원동기, 직무관련 경험 및 역량, 입사 후 포부 및 목표
          </div>
        </li>
      </ul>
      <div class="tit mt-16">추가 팁</div>
      <ul class="list-type-dot mt-16">
        <li>
          경험 기반으로 쓰기
          <div class="description">
            단순히 "저는 성실합니다"가 아니라 왜 그렇게 말할 수 있는지 경험을 근거로 제시해야 설득력이 높습니다.
          </div>
        </li>
        <li>
          회사/직무 맞춤형으로 작성
          <div class="description">
            동일한 자기소개서를 여러 군데 제출하면 티가 납니다. 반드시 해당 기업/직무에 맞는 내용으로 수정하세요.
          </div>
        </li>
        <li>
          분량은 제한을 지켜서
          <div class="description">
            너무 짧거나 너무 길면 불리하게 작용할 수 있습니다.
          </div>
        </li>
        <li>
          첫 글자를 시작하기 어려우면 다음 예시를 참고해보세요.
          <div class="butotn-area">
            <button type="button" class="btn btn-line-box btn-sm"  onclick="openModal(event)" modal-id="introductionEx1">예시 : 자기소개서 (경영사무직, 재취업용)</button>
            <button type="button" class="btn btn-line-box btn-sm"  onclick="openModal(event)" modal-id="introductionEx2">예시 : 자기소개서 (요양보호사, 중장년 남성, 신규 취업용)</button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import { apiHandler } from './resume-common';

export default({
  name: 'introduction-modal-template',
  props: ['introductionModal', 'indbankNo'],
  data() {
    return {
      introduction: {
        selfintro: '',
      },
      selfIntroUseYn: 'Y', // 기본값: 지금 작성하기 (체크박스 비활성화)
      isDisabled: false,
    };
  },
  watch: {
    introductionModal: {
      handler(newVal) {
        if (newVal && this.indbankNo) {
          this.getIntroduction();
          this.getBasic();
        }
      },
      immediate: true,
    },
    selfIntroUseYn(newVal) {
      this.isDisabled = (newVal === 'N');
    },
  },
  methods: {
    getIntroduction() {
      Axios.get(`/api/idb/${this.indbankNo}/introduction`).then((response) => {
        if (response.data.success === 'R') {
          this.introduction = response.data.data || {};
          this.introduction.selfintro = this.introduction.selfintro || '';
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    getBasic() {
      Axios.get(`/api/idb/${this.indbankNo}/basic`).then((response) => {
        if (response.data.success === 'R') {
          this.selfIntroUseYn = response.data.data.selfIntroUseYn || 'Y'; // 값이 없으면 기본값 'Y' 설정
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    reset() {
      const message = '해당화면의 작성 중인 내용이 사라집니다.\n입력하신 내용을 초기화 하시겠습니까?';

      if (confirm(message)) {
        // 자기소개서 내용 완전 초기화
        this.introduction = {
          selfintro: ''
        };

        // '나중에 작성할게요' 체크박스도 초기화 (기본값: 지금 작성)
        this.selfIntroUseYn = 'Y';

        // 비활성화 상태 초기화
        this.isDisabled = false;
      }
    },
    updateIntroduction() {
      // 유효성 검사 실행
      if (!this.validateForm()) {
        return;
      }

      const vm = this; // Vue 인스턴스 참조 저장
      Axios.post(`/api/idb/${this.indbankNo}/introduction`, { selfIntroUseYn: this.selfIntroUseYn, selfintro: this.introduction.selfintro }).then((response) => {
        apiHandler.handleSaveSuccess(response, (res) => {
          // 완성도 업데이트
          if (res.data && res.data.data.completionRate !== undefined) {
            vm.$emit('update:CompletionRate', res.data.data.completionRate);
          }
        });
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    validateSelfIntro() {
      // '나중에 작성할게요'가 체크되어 있으면 검증하지 않음
      if (this.selfIntroUseYn === 'N') {
        return true;
      }

      const selfintro = this.introduction.selfintro;
      if (!selfintro || selfintro.trim() === '') {
        alert('자기소개서를 입력해주세요.');
        return false;
      }

      const bytes = this.getUtf8ByteLength(selfintro);
      if (bytes > 4000) {
        alert('자기소개서는 4000바이트 이하로 입력해주세요.');
        return false;
      }

      return true;
    },
    validateForm() {
      return this.validateSelfIntro();
    },
    handleSelfIntroInput(event) {
      const maxBytes = 4000;
      const value = event.target.value || '';
      const trimmed = this.trimToMaxBytes(value, maxBytes);

      if (trimmed !== value) {
        this.introduction.selfintro = trimmed;
        alert('자기소개서는 4000바이트를 초과할 수 없습니다.\n초과된 내용은 잘렸습니다.');
      } else {
        this.introduction.selfintro = value;
      }
    },
    trimToMaxBytes(value, maxBytes) {
      let bytes = 0;
      let result = '';

      for (const ch of value) {
        const size = this.getUtf8ByteLength(ch);
        if (bytes + size > maxBytes) {
          break;
        }
        bytes += size;
        result += ch;
      }

      return result;
    },
    getUtf8ByteLength(str) {
      let size = 0;
      for (const ch of str) {
        const code = ch.codePointAt(0);
        if (code <= 0x7f) {
          size += 1;
        } else if (code <= 0x7ff) {
          size += 2;
        } else if (code <= 0xffff) {
          size += 3;
        } else {
          size += 4;
        }
      }
      return size;
    },
  },
});
</script>

<style scoped>
.text-area-wrap:disabled {
  background-color: #f8f9fa;
  opacity: 0.6;
}
</style>


// WEBPACK FOOTER //
// Introduction.vue?e2e96844